"use client";

import { usePatientStatusOverdueToasts } from "@/hooks/use-patient-status-overdue-toasts";
export function PatientStatusOverdueToasts() {
  usePatientStatusOverdueToasts();
  return null;
}